import { FCM } from "@capacitor-community/fcm";
import { debugMode, fcmTopicSuffix } from "../config";
function getTopic(topicName: string){
    return `${topicName}-${fcmTopicSuffix}`
}
export function fcmSubscribeToTopic(topicName: string) {
    const topic = getTopic(topicName)
    return FCM.subscribeTo({ topic  })
        .then(() => debugMode && console.log(`Subscribed to topic : ${topic}`))
        .catch(err => debugMode && console.error("Subscription error:", { topicName, err }));
}
export function fcmUnsubscribeFromTopic(topicName: string) {
    const topic = getTopic(topicName)
    return FCM.unsubscribeFrom({ topic})
        .then(() => debugMode && console.log(`Unubscribed from topic : ${topic}`))
        .catch(err => debugMode && console.error("Subscription error:", { topicName, err }));
}